// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"255":"33ad4dfa","787":"29fc5417"}[chunkId] + ".chunk.js";
};